import React, { useState } from 'react';
import './AccountDeletion.css';
import { submitAccountDeletionRequest } from '../api/adminApi';

const AccountDeletion = () => {
  const [formData, setFormData] = useState({
    email: '',
    phoneNumber: '',
    countryCode: '+1',
    reason: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const countries = [
    { code: '+1', flag: 'us.svg', name: 'United States' },
    { code: '+1', flag: 'Canada.svg', name: 'Canada' },
    { code: '+7', flag: 'Belarus.svg', name: 'Belarus' },
    { code: '+30', flag: 'Greece.svg', name: 'Greece' },
    { code: '+31', flag: 'Netherlands.svg', name: 'Netherlands' },
    { code: '+32', flag: 'Belgium.svg', name: 'Belgium' },
    { code: '+33', flag: 'France.svg', name: 'France' },
    { code: '+34', flag: 'Spain.svg', name: 'Spain' },
    { code: '+39', flag: 'Italy.svg', name: 'Italy' },
    { code: '+40', flag: 'Romania.svg', name: 'Romania' },
    { code: '+41', flag: 'Switzerland.svg', name: 'Switzerland' },
    { code: '+44', flag: 'United_Kingdom.svg', name: 'United Kingdom' },
    { code: '+45', flag: 'Denmark.svg', name: 'Denmark' },
    { code: '+46', flag: 'Sweden.svg', name: 'Sweden' },
    { code: '+47', flag: 'Norway.svg', name: 'Norway' },
    { code: '+48', flag: 'Poland.svg', name: 'Poland' },
    { code: '+49', flag: 'Germany.svg', name: 'Germany' },
    { code: '+52', flag: 'Mexico.svg', name: 'Mexico' },
    { code: '+91', flag: 'India.svg', name: 'India' },
    { code: '+298', flag: 'Faroe_Islands.svg', name: 'Faroe Islands' },
    { code: '+350', flag: 'Gibraltar.svg', name: 'Gibraltar' },
    { code: '+351', flag: 'Portugal.svg', name: 'Portugal' },
    { code: '+352', flag: 'Luxembourg.svg', name: 'Luxembourg' },
    { code: '+353', flag: 'Ireland.svg', name: 'Ireland' },
    { code: '+354', flag: 'Iceland.svg', name: 'Iceland' },
    { code: '+355', flag: 'albania.svg', name: 'Albania' },
    { code: '+356', flag: 'Malta.svg', name: 'Malta' },
    { code: '+357', flag: 'Cyprus.svg', name: 'Cyprus' },
    { code: '+358', flag: 'Finland.svg', name: 'Finland' },
    { code: '+359', flag: 'Bulgaria.svg', name: 'Bulgaria' },
    { code: '+370', flag: 'Lithuania.svg', name: 'Lithuania' },
    { code: '+371', flag: 'Latvia.svg', name: 'Latvia' },
    { code: '+372', flag: 'Estonia.svg', name: 'Estonia' },
    { code: '+373', flag: 'Moldova.svg', name: 'Moldova' },
    { code: '+375', flag: 'Belarus.svg', name: 'Belarus' },
    { code: '+376', flag: 'Ando.svg', name: 'Andorra' },
    { code: '+377', flag: 'Monaco.svg', name: 'Monaco' },
    { code: '+378', flag: 'San_Marino.svg', name: 'San Marino' },
    { code: '+380', flag: 'Ukraine.svg', name: 'Ukraine' },
    { code: '+381', flag: 'Serbia.svg', name: 'Serbia' },
    { code: '+382', flag: 'Montenegro.svg', name: 'Montenegro' },
    { code: '+383', flag: 'Kosovo.svg', name: 'Kosovo' },
    { code: '+385', flag: 'Croatia.svg', name: 'Croatia' },
    { code: '+386', flag: 'Slovenia.svg', name: 'Slovenia' },
    { code: '+387', flag: 'Bosnia_and_Herzegovina.svg', name: 'Bosnia and Herzegovina' },
    { code: '+420', flag: 'Czech_Republic.svg', name: 'Czech Republic' },
    { code: '+421', flag: 'Slovakia.svg', name: 'Slovakia' },
    { code: '+423', flag: 'Liechtenstein.svg', name: 'Liechtenstein' },
    { code: '+880', flag: 'bangladesh.svg', name: 'Bangladesh' }
  ];

  const getCountryFlag = (countryCode) => {
    const country = countries.find(c => c.code === countryCode);
    return country ? country.flag : 'us.svg';
  };

  const getCountryName = (countryCode) => {
    const country = countries.find(c => c.code === countryCode);
    return country ? country.name : 'United States';
  };

  const handleCountrySelect = (code, flag, name) => {
    setFormData(prev => ({
      ...prev,
      countryCode: code
    }));
    setShowCountryDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    
    try {
      // Prepare the data for API call - Generate OTP
      const submissionData = {
        email: formData.email,
        phoneNumber: `${formData.countryCode}${formData.phoneNumber}`,
        action: "GENERATE_OTP"
      };
      
      console.log('Requesting OTP for account deletion:', submissionData);
      
      // Try API call first
      try {
        const response = await submitAccountDeletionRequest(submissionData);
        console.log('OTP sent successfully:', response);
        setSubmitMessage('OTP sent successfully! Please check your mobile number for the verification code.');
        setOtpSent(true);
      } catch (apiError) {
        console.warn('API call failed:', apiError);
        
        // Extract error message from API response
        let errorMessage = 'Error sending OTP. Please contact support@lifewink.com directly with your account deletion request.';
        
        if (apiError.response && apiError.response.data) {
          const errorData = apiError.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          }
        }
        
        setSubmitMessage(errorMessage);
        setOtpSent(false);
      }
      
    } catch (error) {
      console.error('Error requesting OTP:', error);
      setSubmitMessage('Error requesting OTP. Please contact support@lifewink.com directly with your account deletion request.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setIsVerifying(true);
    setSubmitMessage('');
    
    try {
      // Prepare the data for OTP verification
      const verificationData = {
        email: formData.email,
        phoneNumber: `${formData.countryCode}${formData.phoneNumber}`,
        action: "VERIFY_OTP",
        otp: otp
      };
      
      console.log('Verifying OTP for account deletion:', verificationData);
      
      // Try API call for OTP verification
      try {
        const response = await submitAccountDeletionRequest(verificationData);
        console.log('Account deletion request submitted successfully:', response);
        setSubmitMessage('Account deletion request submitted successfully!');
        
        // Reset form after successful submission
        setFormData({
          email: '',
          phoneNumber: '',
          countryCode: '+1',
          reason: ''
        });
        setOtpSent(false);
        setOtp('');
        
      } catch (apiError) {
        console.warn('API call failed:', apiError);
        
        // Extract error message from API response
        let errorMessage = 'Error verifying OTP. Please contact support@lifewink.com directly with your account deletion request.';
        
        if (apiError.response && apiError.response.data) {
          const errorData = apiError.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          }
        }
        
        setSubmitMessage(errorMessage);
      }
      
    } catch (error) {
      console.error('Error verifying OTP:', error);
      setSubmitMessage('Error verifying OTP. Please contact support@lifewink.com directly with your account deletion request.');
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="account-deletion-page">
      <div className="account-deletion-header">
        <img 
          src="/assets/Blue-Logo.svg" 
          alt="LIFEWINK Logo" 
          className="header-logo"
        />
      </div>
      <div className="account-deletion-container">
        <div className="account-deletion-content">
        <h1 className="page-title">Account Deletion</h1>
        <p className="page-description">
          Please enter the below details to request for Account deletion.
        </p>
        
        <div className="form-card">
          <h2 className="form-title">Registered Account Details</h2>
          
          <form onSubmit={handleSubmit} className="deletion-form">
            {!otpSent && (
              <>
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Registered email address<span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Registered email address"
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phoneNumber" className="form-label">
                    Registered phone number<span className="required-asterisk">*</span>
                  </label>
                  <div className="phone-input-container">
                    <div className="country-code-dropdown">
                      <button
                        type="button"
                        className="country-code-button"
                        onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                      >
                        <img
                          src={`/assets/flags/${getCountryFlag(formData.countryCode)}`}
                          alt={getCountryName(formData.countryCode)}
                          className="flag-icon"
                        />
                        <span className="dropdown-arrow">▼</span>
                      </button>
                      {showCountryDropdown && (
                        <div className="country-dropdown-menu">
                          {countries.map((country, index) => (
                            <div 
                              key={`${country.code}-${index}`}
                              className="country-option"
                              onClick={() => handleCountrySelect(country.code, country.flag, country.name)}
                              title={`${country.name} (${country.code})`}
                            >
                              <img 
                                src={`/assets/flags/${country.flag}`} 
                                alt={country.name} 
                                className="flag-icon" 
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      placeholder="(000) 000-0000"
                      className="phone-input"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="reason" className="form-label">
                    Reason for Account Deletion
                  </label>
                  <textarea
                    id="reason"
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                    placeholder="Enter the reason"
                    className="form-textarea"
                    rows="4"
                  />
                </div>
              </>
            )}

            {!otpSent ? (
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Requesting OTP...' : 'Request OTP'}
              </button>
            ) : (
              <div className="otp-verification">
                <div className="form-group">
                  <label htmlFor="otp" className="form-label">
                    Enter OTP<span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    id="otp"
                    name="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter 6-digit OTP"
                    className="form-input"
                    required
                    maxLength="6"
                  />
                </div>
                <button 
                  type="button" 
                  onClick={handleOtpVerification}
                  className="submit-button"
                  disabled={isVerifying || !otp.trim()}
                >
                  {isVerifying ? 'Verifying...' : 'Submit'}
                </button>
              </div>
            )}
            
            {submitMessage && (
              <div className={`submit-message ${submitMessage.includes('Error') ? 'error' : 'success'}`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
    </div>
  );
};

export default AccountDeletion;
